import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { buildSignupCountrySignals } from "./countryAttribution";

export async function captureSignupCountryAfterRegistration() {
  try {
    const callable = httpsCallable(functions, "captureUserSignupCountry");
    const signals = buildSignupCountrySignals();
    await callable(signals);
  } catch (error) {
    console.warn("Unable to capture signup country:", error);
  }
}

export { buildSignupCountrySignals };
